import React from 'react';
import { Archive, Loader2, Search } from 'lucide-react';
import { LiberaSpazio } from './LiberaSpazio';

export const ProgressoScansioni = ({ job }) => {
  if (!job?.in_corso) return null;
  const fatti = Math.max(0, job.totale - job.in_coda);
  const perc = job.totale ? Math.round((fatti / job.totale) * 100) : 0;
  return (
    <div className="rounded-xl p-3 border border-purple-500/30 bg-purple-500/10 lg:bg-purple-50 lg:border-purple-200" data-testid="archivio-progresso">
      <p className="flex items-center gap-2 text-sm font-medium text-purple-200 lg:text-purple-800">
        <Loader2 className="h-4 w-4 animate-spin" />
        Preparo le scansioni in sottofondo… {fatti}/{job.totale}
      </p>
      <p className="text-xs text-purple-300/80 lg:text-purple-700/80 mt-0.5" data-testid="archivio-progresso-nota">
        Puoi chiudere questa pagina e continuare a usare l'app: il server le completa da solo.
      </p>
      <div className="mt-2 h-1.5 rounded-full bg-purple-900/40 lg:bg-purple-100 overflow-hidden">
        <div className="h-full bg-purple-500 transition-[width] duration-500" style={{ width: `${perc}%` }} />
      </div>
    </div>
  );
};

export const ArchivioIntestazione = ({ dati, cerca, onCerca, onAnno }) => (
  <div className="space-y-3" data-testid="archivio-intestazione">
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0">
        <h2 className="text-lg font-bold text-white lg:text-gray-900 flex items-center gap-2" data-testid="archivio-titolo">
          <Archive className="h-5 w-5 text-purple-300 lg:text-purple-600" />
          Archivio DDT {dati.anno || ''}
        </h2>
        <p className="text-xs text-slate-400 lg:text-gray-500 mt-0.5" data-testid="archivio-riepilogo">
          {dati.totale || 0} DDT · {dati.con_scansione || 0} scansioni pronte · {dati.mancanti || 0} senza scansione
        </p>
      </div>
      <LiberaSpazio />
    </div>
    {dati.anni.length > 0 && (
      <div className="flex gap-2 overflow-x-auto pb-1" data-testid="archivio-anni">
        {dati.anni.map((a) => (
          <button key={a} type="button" onClick={() => onAnno(a)} data-testid={`archivio-anno-${a}`}
            className={`px-4 py-1.5 rounded-full text-sm font-semibold whitespace-nowrap transition-colors ${
              a === dati.anno
                ? 'bg-purple-600 text-white'
                : 'bg-slate-800/80 text-slate-300 border border-slate-700 lg:bg-white lg:text-gray-600 lg:border-gray-200 hover:border-purple-400'
            }`}>
            {a}
          </button>
        ))}
      </div>
    )}
    <div className="relative">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-500 lg:text-gray-400" />
      <input value={cerca} onChange={(e) => onCerca(e.target.value)} placeholder="Cerca fornitore o numero DDT..."
        data-testid="archivio-cerca"
        className="w-full pl-10 pr-4 py-2.5 rounded-xl text-sm bg-black/40 border border-slate-700/50 text-white placeholder-slate-500 lg:bg-white lg:border-gray-200 lg:text-gray-900 lg:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500" />
    </div>
  </div>
);
